import React from "react";
import "./yellowButton.scss";

const YellowButton = ({ text, onClick, padding, font }) => {
    return (
        <div className="yellow-button unselectable" onClick={onClick} style={{ padding: padding, fontSize: font }}>
            {text}
        </div>
    );
};

export default YellowButton;
